import React from 'react';
import { Modal } from 'antd';

import Button from 'components/Button';
import DF from 'DisplayFramework';
import PropDetail from 'pages/ProposalV3/PropDetail/index';

type ProposalModalProps = {
  onCancel: () => void;
  ctrid: number;
  visible: boolean;
  copy?: boolean;
  title: React.ReactNode | string;
  onSuccess?: () => void;
  iscreate?: boolean;
  showAsModal?: boolean;
  phase?: 'PROPOSAL' | 'PROD' | any;
};

const ProposalModal = (props: ProposalModalProps) => {
  const { onCancel, ctrid, visible, title, iscreate, copy, phase } = props;

  return (
    <DF.Provider pagcode="contract">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1400}
         title={title??[]}
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
        
      >
        <PropDetail
          phaseProp={phase}
          showAsModal
          ctrid={ctrid}
          onCancel={onCancel}
          copy={copy}
          isCreate={iscreate}
        />
      </Modal>
    </DF.Provider>
  );
};

export default ProposalModal;
